import { GetterTree } from 'vuex';
import { RootStateShape, FeatureStateShape } from 'store';

export default {
	isFeatureEnabled: (state) => (featureName: string) => {
		return state.features.includes(featureName);
	}
} as GetterTree<FeatureStateShape, RootStateShape>;
